<template>
  <el-row :gutter="20">
    <el-col :md="17">
      <el-form
        v-loading="loadingTemplate"
        :model="template"
      >
        <h1 style="font-size: 20px; margin-bottom: 30px;">
          Notification Templates
        </h1>
        <el-form-item label="Subject">
          <el-input
            v-model="template.email_subject"
            placeholder="Subject"
            clearable
          />
        </el-form-item>
        <el-form-item label="Reply-to">
          <el-input
            v-model="template.email_reply_to"
            placeholder="Reply-to"
            clearable
          />
        </el-form-item>
        <el-form-item label="Header Colour">
          <el-color-picker
            v-model="template.email_header_colour"
            placeholder="Header Colour"
          />
        </el-form-item>
        <el-form-item label="Header URL">
          <el-input
            v-model="template.email_header_url"
            placeholder="Header URL"
            clearable
          />
        </el-form-item>
        <el-form-item label="Header Text">
          <el-input
            v-model="template.email_header_text"
            placeholder="Header Text"
            clearable
          />
        </el-form-item>
        <el-form-item label="Greeting">
          <el-input
            v-model="template.email_greeting"
            placeholder="Greeting"
            clearable
          />
        </el-form-item>
        <el-form-item label="Email Line One">
          <el-input
            v-model="template.email_line_one"
            type="textarea"
            :rows="3"
            placeholder="Please input email line one content..."
          />
        </el-form-item>
        <el-form-item label="Email Line Two">
          <el-input
            v-model="template.email_line_two"
            type="textarea"
            :rows="3"
            placeholder="Please input email line two content..."
          />
        </el-form-item>
        <el-form-item label="Email Action">
          <el-input
            v-model="template.email_action"
            placeholder="Email Action"
            clearable
          />
        </el-form-item>
        <el-form-item label="Salutation">
          <el-input
            v-model="template.email_salutation"
            placeholder="Salutation"
            clearable
          />
        </el-form-item>
        <el-form-item label="Email Footer">
          <el-input
            v-model="template.email_footer_text"
            placeholder="Email Footer"
            clearable
          />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button
            type="primary"
            :disabled="loadingTemplate"
            @click.native="save()"
          >
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :md="7">
      <el-row>
        <el-col>
          <el-card shadow="hover">
            <p>Select a Team</p>
            <el-select
              v-model="selectedTeam"
              v-loading="loadingTeams"
              placeholder="Select a Team"
              class="w-100"
              clearable
            >
              <el-option
                v-for="team in teams"
                :key="team.id"
                :label="team.name"
                :value="team.id"
              />
            </el-select>
          </el-card>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-col>
          <el-card
            v-loading="loadingTypes"
            shadow="hover"
          >
            <p>Notification Template</p>
            <ul style="list-style: none; padding: 0; margin: 0;">
              <li
                v-for="type in types"
                :key="type.id"
                class="type-item"
                :class="{'selected-type': (selectedType === type.id)}"
                @click.native="selectedType = type.id"
              >
                <span>{{ type.description }}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-col>
          <el-card shadow="hover">
            <el-collapse value="0">
              <el-collapse-item
                title="Placeholders"
                name="1"
              >
                <p><strong>Consignment Number:</strong></p>
                <p v-pre>
                  {{ consignment_number }}
                </p>
                <p><strong>Receiver Name:</strong></p>
                <p v-pre>
                  {{ receiver_name }}
                </p>
                <p><strong>Receiver Address:</strong></p>
                <p v-pre>
                  {{ receiver_address }}
                </p>
                <p><strong>Receiver Contact:</strong></p>
                <p v-pre>
                  {{ receiver_contact }}
                </p>
                <p><strong>Receiver Phone:</strong></p>
                <p v-pre>
                  {{ receiver_phone }}
                </p>
                <p><strong>Sender Name:</strong></p>
                <p v-pre>
                  {{ sender_name }}
                </p>
                <p><strong>Sender Address:</strong></p>
                <p v-pre>
                  {{ sender_address }}
                </p>
                <p><strong>Sender Contact:</strong></p>
                <p v-pre>
                  {{ sender_contact }}
                </p>
                <p><strong>Sender Phone:</strong></p>
                <p v-pre>
                  {{ sender_phone }}
                </p>
                <p><strong>Consignment Reference:</strong></p>
                <p v-pre>
                  {{ consignment_reference }}
                </p>
                <p><strong>Special Instruction:</strong></p>
                <p v-pre>
                  {{ special_instruction }}
                </p>
                <p><strong>Manifest Date:</strong></p>
                <p v-pre>
                  {{ manifest_date }}
                </p>
                <p><strong>Number Of Items:</strong></p>
                <p v-pre>
                  {{ number_of_items }}
                </p>
                <p><strong>Total Weight:</strong></p>
                <p v-pre>
                  {{ total_weight }}
                </p>
                <p><strong>Total Volume:</strong></p>
                <p v-pre>
                  {{ total_volume }}
                </p>
                <p><strong>Cost Centre:</strong></p>
                <p v-pre>
                  {{ cost_centre }}
                </p>
                <p><strong>Your Business Name:</strong></p>
                <p v-pre>
                  {{ your_business_name }}
                </p>
                <p><strong>Your Business Phone:</strong></p>
                <p v-pre>
                  {{ your_business_phone }}
                </p>
                <p><strong>Event Time:</strong></p>
                <p v-pre>
                  {{ event_time }}
                </p>
                <p><strong>Item Reference:</strong></p>
                <p v-pre>
                  {{ item_reference }}
                </p>
                <p><strong>Item Description:</strong></p>
                <p v-pre>
                  {{ item_description }}
                </p>
                <p><strong>Tracking Status:</strong></p>
                <p v-pre>
                  {{ tracking_status }}
                </p>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      types: [],
      selectedType: null,
      teams: [],
      selectedTeam: null,
      // customToolbar: [
      //   [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      //   ['bold', 'italic', 'underline'],        // toggled buttons
      //   ['blockquote', 'code-block'],
      //   [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      //   [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      //   ['clean']                                         // remove formatting button
      // ],
      template: {},
      isDefaultTemplate: false,
      loadingTeams: true,
      loadingTypes: true,
      loadingTemplate: false
    }
  },
  watch: {
    selectedType (newVal) {
      this.getTemplateByAccountTeamAndType()
    },
    selectedTeam (newVal) {
      this.getTemplateByAccountTeamAndType()
    }
  },
  created () {
    this.getTeams()
    this.getTemplateTypes()
  },
  methods: {
    getTeams () {
      this.$sdk.team.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
      }).then(res => {
        this.teams = res
        this.teams.unshift({ id: '', name: 'All Teams' })
      }).finally(() => {
        this.loadingTeams = false
      })
    },
    getTemplateTypes () {
      this.$sdk.notificationtemplatetype.list()
        .then(res => {
          this.types = res.filter(type => type.template !== null && type.template !== '')
          this.selectedType = this.types[0].id
        })
        .finally(() => {
          this.loadingTypes = false
        })
    },
    getTemplateByAccountTeamAndType () {
      this.loadingTemplate = true
      this.$sdk.notificationtemplate.list(builder => {
        builder.filters = { type: this.selectedType }
        if (this.selectedTeam) {
          builder.filters = { team: this.selectedTeam }
        } else {
          builder.filters = { account: this.accountId }
        }
      }).then(res => {
        if (res.length > 0) {
          this.template = res[0]
          this.isDefaultTemplate = false
          this.loadingTemplate = false
        } else {
          this.getDefaultTemplateByType()
        }
      }).catch(error => {
        this.getDefaultTemplateByType()
        throw error
      })
    },
    getDefaultTemplateByType () {
      this.$sdk.notificationtemplate.list(builder => {
        builder.filters = { type: this.selectedType }
        builder.filters = { is_default: 'true' }
      }).then(res => {
        if (res.length > 0) {
          this.template = res[0]
          this.isDefaultTemplate = true
        }
      })
        .finally(() => {
          this.loadingTemplate = false
        })
    },
    save () {
      this.loadingTemplate = true
      if (!this.isDefaultTemplate) {
        this.template.update()
          .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
          .finally(() => {
            this.loadingTemplate = false
          })
      } else {
        this.template.type = this.selectedType
        this.template.id = null
        this.template.created_at = null
        if (this.selectedTeam) {
          this.template.account = null
          this.template.team = this.selectedTeam
        } else {
          this.template.account = this.accountId
          this.template.team = null
        }
        this.$sdk.notificationtemplate.create(this.template, builder => {
        }).then(res => {
          this.isDefaultTemplate = false
          this.template = res
          this.$message({ message: 'Successfully saved', type: 'success' })
        })
          .finally(() => {
            this.loadingTemplate = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "variables";
.type-item {
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: $light;
  }
}
.selected-type {
  background-color: $brand;
  color: $white;
  &:hover {
    color: #303133;
  }
}
</style>
